import { GlobalFileData } from "../../../Files/GlobalFileData";
import { PropertyFileData } from "../../PropertyFileData";

export function getExternalLink(fileData: GlobalFileData | PropertyFileData): { name: string; url: string } | undefined {
  if (fileData.externalFileClientID === "findable" && fileData.externalRefs.findable?.id && fileData.externalFileMetadata.propertyID) {
    return {
      name: "Findable",
      url: `https://app.findable.no/buildings/${fileData.externalFileMetadata.propertyID}/?documentId=${fileData.externalRefs.findable.id}`,
    };
  }
}

export interface ExternalFileMetadata {
  propertyID?: string;
}
